import React from "react";
import { FaSync, FaUserCheck, FaVoteYea, FaPoll } from "react-icons/fa";

export default function UserVoteDashboardHeader({ loading, onRefresh, userId }) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="relative overflow-hidden bg-gradient-to-r from-[#013E8E] via-indigo-600 to-blue-600 px-5 py-7 text-white sm:px-7 lg:px-8">
        <div className="absolute -right-16 -top-16 h-44 w-44 rounded-full bg-white/10 blur-2xl" />
        <div className="absolute -bottom-20 -left-16 h-56 w-56 rounded-full bg-[#4CA82F]/20 blur-2xl" />

        <div className="relative flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-bold uppercase tracking-[0.18em] ring-1 ring-white/20">
              <FaVoteYea />
              Espace utilisateur
            </div>

            <h1 className="mt-4 text-2xl font-bold sm:text-3xl">
              Votes & sondages proposés
            </h1>

            <p className="mt-3 max-w-3xl text-sm leading-6 text-white/90 sm:text-base">
              Participez aux consultations ouvertes du club et retrouvez les
              réponses déjà envoyées.
            </p>

            {!userId && (
              <p className="mt-3 rounded-2xl bg-amber-400/20 px-4 py-3 text-sm font-bold text-white ring-1 ring-amber-200/30">
                Utilisateur non identifié : les votes peuvent être affichés,
                mais la participation nécessite un compte connecté.
              </p>
            )}
          </div>

          <div className="flex flex-col gap-3 sm:flex-row lg:flex-col xl:flex-row">
            <HeaderBadge icon={FaPoll} label="Votes et sondages" />
            <HeaderBadge icon={FaUserCheck} label="Une réponse par vote" />

            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex min-h-[50px] items-center justify-center gap-2 rounded-2xl bg-white px-4 py-3 text-sm font-bold text-slate-900 shadow-sm transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-70"
            >
              <FaSync className={loading ? "animate-spin" : ""} />
              Rafraîchir
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

function HeaderBadge({ icon: Icon, label }) {
  return (
    <div className="rounded-2xl bg-white/15 px-4 py-3 text-white ring-1 ring-white/20 backdrop-blur">
      <div className="flex items-center gap-3">
        <span className="grid h-10 w-10 place-items-center rounded-xl bg-white/15">
          <Icon />
        </span>

        <span className="text-sm font-bold">{label}</span>
      </div>
    </div>
  );
}